export const LocalisedDate = {
  methods: {
    localisedSeconds(seconds) {
      return this.localisedDate(seconds * 1000);
    },

    localisedDate(time) {
      var date = new Date(time);

      const days = [
        this.$t('calender.su'),
        this.$t('calender.mo'),
        this.$t('calender.tu'),
        this.$t('calender.we'),
        this.$t('calender.th'),
        this.$t('calender.fr'),
        this.$t('calender.sa'),
      ];

      const months = [
        this.$t('calender.jan'),
        this.$t('calender.feb'),
        this.$t('calender.mar'),
        this.$t('calender.apr'),
        this.$t('calender.mai'),
        this.$t('calender.jun'),
        this.$t('calender.jul'),
        this.$t('calender.aug'),
        this.$t('calender.sep'),
        this.$t('calender.oct'),
        this.$t('calender.nov'),
        this.$t('calender.dec'),
      ];

      var month = months[date.getMonth()];
      var day = days[date.getDay()];

      var hour = date.getHours();
      var min = ('0' + date.getMinutes()).slice(-2);
      var o = {};
      o.month = month;
      o.date = date.getDate();
      o.day = day;
      o.hour = hour;
      o.minute = min;
      o.time = hour + ':' + min;
      return o;
    },
  },
};
